import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { formatPrice, formatRange } from "@/lib/currency";

export default function FAQ({ currency, rates }) {
  const items = [
    {
      q: "What’s actually included in the build price?",
      a: `Everything you’d expect from a polished launch — design, build, mobile optimisation, basic SEO, going live on your domain. The starting price is ${formatPrice(150, currency, rates)} for a one-pager, and most small business sites land between ${formatRange(200, 400, currency, rates)}.`,
    },
    {
      q: "Do I need to pay anything to get a quote?",
      a: "Not a penny. Send the form, we reply within a working day with a fixed price. You decide from there.",
    },
    {
      q: "What does the maintenance plan cover?",
      a: `${formatPrice(25, currency, rates)}/month is a truly hands-off plan. Oakbridg handles hosting, security updates, backups, uptime monitoring, SSL renewals, domain reminders and any tweak under 15 minutes. You never log into a dashboard, never chase a developer.`,
    },
    {
      q: "Do I have to take the maintenance plan?",
      a: `The plan is included by default and it's how most clients prefer to run things — it means nothing about your site is your problem to think about. If you'd rather self-host, that's a conversation we'd have upfront and price accordingly.`,
    },
    {
      q: "How are modifications priced?",
      a: `Modifications run ${formatRange(50, 150, currency, rates)} depending on size — a new section, a new page, or a small new feature. You always get a quote first.`,
    },
    {
      q: "Do I own the website?",
      a: "Yes — the content, the domain and everything client-facing is yours. The site itself runs on Oakbridg's stack (our hosting, our deployment pipeline, our integrations), and that's what your monthly plan pays for. Most clients happily stay on it because it's genuinely hands-off — but you're never locked in.",
    },
    {
      q: "What if I want to move the site elsewhere later?",
      a: "That's fine. If you decide to take the hosting into your own hands, we'll hand over a clean copy of the code, transfer the domain to you and send a written guide covering the environment variables, database setup and deployment steps you'll need. From that point on, hosting, updates and maintenance become your responsibility (or your new provider's) — we're happy to answer a couple of clarifying questions during handover, but ongoing support stops once the site leaves our stack.",
    },
    {
      q: "How quickly can it go live?",
      a: "Most projects launch within 7 days from kickoff. We tell you the exact timeline up front, in writing.",
    },
  ];

  return (
    <section id="faq" data-testid="faq-section" className="border-t border-[#E5E0D8] bg-white">
      <div className="oak-container oak-section">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20 items-start">
          <div>
            <p className="text-sm uppercase tracking-[0.18em] text-[#5C665F]">FAQ</p>
            <h2 className="font-heading font-bold text-3xl md:text-5xl tracking-tight mt-3 text-[#1A3622]">
              The honest answers.
            </h2>
            <p className="mt-5 text-[17px] leading-relaxed text-[#5C665F]">
              If something isn’t covered here, just ask — we’ll add it.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {items.map((it, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="border-b border-[#E5E0D8]"
              >
                <AccordionTrigger className="text-left font-heading font-bold text-lg md:text-xl text-[#1C211E] hover:no-underline hover:text-[#1A3622] py-5">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-[16px] text-[#5C665F] leading-relaxed pb-6">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
